<ng-container *transloco="let t; read: 'dashboard-options-component.dashboard-option-general'">
  <section class="settings-section">
    <div class="section-title">
      <h3>{{ t('basic-settings') }}</h3>
      <p>{{ t('settings-sub-header') }}</p>
    </div>

    <div class="section-field">
      <label>{{ t('title') }}</label>
      <div class="name-wrapper">
        <xi-input-field
          required
          [(ngModel)]="dashboard.title"
          [status]="dashboardTitleStatus"
          (onChange)="nameValidator$.next(dashboard.title)"
          [disabled]="isReadOnly || dashboard.locked"
        >
        </xi-input-field>

        @if (isLoading.isValidating) {
          <div class="xi-loader-container__inline-overlay">
            <xi-animation
              [height]="75"
              [width]="75"
              [loop]="true"
              animation="cx_loader"
            ></xi-animation>
          </div>
        }
      </div>

      <label style="align-self: start">{{ t('notes') }}</label>
      <xi-text-area
        ngDefaultControl
        [(ngModel)]="dashboard.payload.notes"
        (onChange)="dashboardChanged.emit(dashboard)"
        placeholder="{{ t('notes-placeholder') }}"
        [height]="100"
        [disabled]="isReadOnly || dashboard.locked"
      ></xi-text-area>

      <label>{{ t('cache') }}</label>
      <xi-default-button
        type="button"
        text="{{ t('clear-data') }}"
        fill="text"
        iconLeft="remove_circle"
        (onClick)="clearUserCache.emit()"
        [disabled]="dashboard.locked"
      ></xi-default-button>
    </div>
  </section>

  <section class="sentiment-section">
    <div class="section-title">
      <h3>{{ t('sentiment') }}</h3>
      <p>{{ t('sentiment-sub-header') }}</p>
    </div>
    <div class="section-field">
      <label id="sentiment-scale">{{ t('sentiment-scale') }}</label>
      <xi-toggle-switch
        color="CX"
        leftText="{{ t('3-point') }}"
        rightText="{{ t('5-point') }}"
        type="button"
        [isToggled]="dashboard.payload.sentimentScale === 3 ? false : true"
        [changeColorOnToggle]="false"
        (onToggle)="onSentimentScaleChanged()"
        [disabled]="isReadOnly || dashboard.locked"
      ></xi-toggle-switch>

      @if (
        dashboard.payload.sentimentScale === 3 && dashboardOriginal.payload.sentimentScale !== 3
      ) {
        <span class="info-text">
          {{ t('sentiment-text-1') }}
        </span>
      }
      @if (
        dashboard.payload.sentimentScale === 5 && dashboardOriginal.payload.sentimentScale !== 5
      ) {
        <span class="info-text">
          {{ t('sentiment-text-2') }}
        </span>
      }

      <label id="sentiment-display">{{ t('sentiment-display') }}</label>

      <xi-toggle-switch
        color="CX"
        leftText="{{ t('polarity') }}"
        rightText="{{ t('numeric') }}"
        type="button"
        [isToggled]="dashboardOriginal.payload.sentimentDisplay === 'polarity' ? false : true"
        [changeColorOnToggle]="false"
        (onToggle)="onSentimentDisplayChanged($event.detail.text)"
        [disabled]="isReadOnly || dashboard.locked"
      ></xi-toggle-switch>
    </div>
  </section>

  <section class="filters-section">
    <div class="section-title">
      <h3>{{ t('dashboard-filters') }}</h3>
      <p>{{ t('dashboard-filters-sub-header') }}</p>
    </div>

    <div class="section-field">
      <label id="dashboard-filters">{{ t('dashboard-filters-toggle') }}</label>
      <xi-toggle-switch
        color="CX"
        leftText="{{ t('no') }}"
        rightText="{{ t('yes') }}"
        type="button"
        [isToggled]="hasDashboardLevelWidgetGroup(dashboard)"
        (onToggle)="onDashboardLevelWidgetGroupChanged()"
        [disabled]="isReadOnly || dashboard.locked"
      ></xi-toggle-switch>

      @if (
        !hasDashboardLevelWidgetGroup(dashboard) && hasDashboardLevelWidgetGroup(dashboardOriginal)
      ) {
        <span class="info-text">{{ t('dashboard-filters-info') }} </span>
      }
    </div>
  </section>

  <section class="alias-section">
    <div class="section-title">
      <h3>{{ t('dashboard-aliases') }}</h3>
      <p>{{ t('alias-sub-header') }}</p>
    </div>

    <div class="section-field">
      <label>{{ t('aliases') }}</label>

      <div [matTooltip]="aliasCreateTooltip">
        <xi-default-button
          text="{{ t('alias-text') }}"
          fill="no-fill"
          buttonSize="small"
          iconRight="add_circle"
          [disabled]="isReadOnly"
          (onClick)="onCreateAlias()"
        ></xi-default-button>
      </div>

      <div class="alias-list-wrapper">
        @if (!aliases) {
          <div class="xi-loader-container__center">
            <xi-animation
              [height]="75"
              [width]="75"
              [loop]="true"
              animation="cx_loader"
            ></xi-animation>
          </div>
        } @else {
          @if (!aliases.length) {
            <div class="alias-list-empty">{{ t('no-aliases') }}</div>
          }
          @for (alias of aliases; track alias) {
            <div class="alias-list-name">{{ alias.name }}</div>
            <xi-toggle-switch
              color="CX"
              [isToggled]="alias.shareable"
              (onToggle)="onShareableToggle($event.detail.isToggled, alias)"
            ></xi-toggle-switch>
            <xi-icon-button
              icon="copy"
              [tooltip]="{ text: t('copy-alias'), direction: 5 }"
              (onClick)="onCopyAlias(alias)"
            ></xi-icon-button>
            <xi-icon-button
              icon="trash"
              [tooltip]="{ text: aliasDeleteTooltip, direction: 5 }"
              [disabled]="isReadOnly"
              (onClick)="onDeleteAlias(alias)"
            ></xi-icon-button>
          }
        }
      </div>
    </div>
  </section>
</ng-container>

@if (showCreateAliasModal) {
  <app-lex-xi-modal
    [isVisible]="showCreateAliasModal"
    maxWidth="500px"
    (close)="onCreateAliasModalClosed()"
  >
    <ng-template appXIModalContent>
      @if (showCreateAliasModal) {
        <app-create-alias-dialog
          [dashboardId]="dashboard.id"
          (modalClosed)="onCreateAliasModalClosed($event)"
        ></app-create-alias-dialog>
      }
    </ng-template>
  </app-lex-xi-modal>
}
